import KeyAccountLayout from "@/layouts/KeyAccountLayout.vue";

import type { RouteRecordRaw } from "vue-router";

const profileRoutes: RouteRecordRaw[] = [
  {
    path: "/profile",
    name: "profile",
    component: () =>
      import("@/views/restricted/profile/ProfileDetailLayoutView.vue"),
    meta: {
      layout: KeyAccountLayout,
      menuSelected: "profile",
      requiresAuth: true,
    },
  },
  {
    path: "/profile/collaborators/:collaboratorId/edit",
    name: "profileCollaborator",
    component: () =>
      import("@/views/restricted/profile/ProfileCollaboratorView.vue"),
    meta: {
      layout: KeyAccountLayout,
      menuSelected: "profile",
      requiresAuth: true,
    },
  },
];

export default profileRoutes;
